// extracted by mini-css-extract-plugin
export default {"list":"WorkspaceDetail_list__xtbaC","square":"WorkspaceDetail_square__vd1mi","placeholderImage":"WorkspaceDetail_placeholderImage__2XMoF","row":"WorkspaceDetail_row__gij3p"};